import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <section className="contact-wrapper" id="contact">

      {/* CONTACT FORM */}
      <div className="contact-form-section" data-aos="fade-up">
        {/* <h2 className="section-title">Ready To Start Your Project?</h2> */}
        <h2 className="section-title">Get In Touch</h2>

        <div className="contact-card" data-aos="zoom-in">
          <form className="contact-form">

            <div className="form-group">
              <input type="text" placeholder="Your Name" required />
            </div>

            <div className="form-group">
              <input type="email" placeholder="Email Address" required />
            </div>

            <div className="form-group">
              <input type="text" placeholder="Phone Number" required />
            </div>

            <div className="form-group">
              <textarea placeholder="Your Message" rows="5" required></textarea>
            </div>

            <button type="submit" className="contact-submit">Send Message</button>
          </form>
        </div>
      </div>

    </section>
  );
}
